export default "__VITE_ASSET__7ef90bfe__"